/**
 * MiBodega - Setup de internacionalizacion (I.1).
 *
 * Default locale es-CO (mercado primario). Soporte inicial es-CO + en-US.
 * La deteccion automatica viene en I.4; este archivo deja la base lista.
 *
 * Los archivos de traduccion viven en ./locales/{locale}.json. Sprint 99
 * solo trae un set minimo para validar la integracion; la extraccion
 * completa de strings hardcoded es I.2.
 *
 * Uso tipico en componentes:
 *   const { t } = useTranslation();
 *   <button>{t('common.save')}</button>
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es.json';
import en from './locales/en.json';
export const SUPPORTED_LOCALES = ['es-CO', 'en-US'];
export const DEFAULT_LOCALE = 'es-CO';
void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources: {
        'es-CO': { translation: es },
        'en-US': { translation: en },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    load: 'currentOnly',
    interpolation: { escapeValue: false }, // React ya escapa por default
    detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'mibodega.locale',
        caches: ['localStorage'],
    },
    react: { useSuspense: false },
    returnNull: false,
});
export default i18n;
//# sourceMappingURL=config.js.map